// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"99ff0118","453":"672adfab","732":"3eae9892","977":"3b99cac2"}[chunkId] + ".chunk.js";
};